module.exports = __webpack_public_path__ + "img/mirdc.9c2748cd.png";